import '.i9{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.ia{padding:1.5rem 0;}.ssr-plugin'
import '.b8{border:none;}.ssr-plugin'
import '.fa{background:transparent;}.ssr-plugin'
import '.av{cursor:pointer;}.ssr-plugin'
import '.gg{text-align:left;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.co{width:1.5rem;}.ssr-plugin'
import '.ib{font-size:1.25rem;}.ssr-plugin'
import '.dg{font-weight:700;}.ssr-plugin'
import '.ic{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="i9"
      style={{
        ...style,
      }}
    >
      <button className="a a0 ia b8 fa av gg"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="bn a c i co ib dg"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="ic"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
